import { useMutation, useQuery } from "@tanstack/react-query";
import client from "./config"; // Assuming this is your Axios instance
// Import axios here if it's not part of your client

// Mutation to schedule a challenge
const scheduleChallenge = async (challengeData) => {
    const response = await client.post('/api/schedule-challenge', challengeData);
    return response.data;
};

const useSubmitForm = () => {
    return useMutation({
        mutationFn: scheduleChallenge,
    });
};

// Fetch the list of challenge types
const fetchChallengeTypes = async () => {
    const response = await client.get('/api/challenge-types'); // Make sure the correct endpoint is used
    return response.data;
};
// Fetch all challenges by user ID
const fetchChallengesByUser = async (UserID) => {
    if (!UserID) throw new Error("UserID is required");

    const response = await client.get(`/api/getallchallenges?UserID=${UserID}`);
    return response.data;
};

const fetchChallengePosts = async (challengeId, userId, status) => {
    const response = await client.get(`/api/challengePostContext?challengeId=${challengeId}&userId=${userId}&status=${status}`);
    if (!response.data) {
        throw new Error('No data found for the given challengeId and userId');
    }
    return response.data;
};

const useChallengePosts = (challengeId, userId, status) => {
    return useQuery({
        queryKey: ['challengePosts', challengeId, userId, status],
        queryFn: () => fetchChallengePosts(challengeId, userId, status),
        enabled: !!challengeId && !!userId, // only fetch when both values are available
    });
};

const approveChallengePost = async (challengePostID, status) => {
    const res = await client.put(`/api/challengeposts/${challengePostID}/approve`, {
        status,
    });
    return res.data;
};

const useApproveChallengePost = () => {
    return useMutation({
        mutationFn: ({ challengePostID, status }) => approveChallengePost(challengePostID, status),

    });

}

const updateChallengePost = async (formData, ChallengePostID) => {
    const res = await client.put(
        `/api/challengeposts/${ChallengePostID}/update`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );
    return res.data;
};

const useUpdateChallengePost = () => {
    return useMutation({
        mutationFn: ({ formData, ChallengePostID }) =>
            updateChallengePost(formData, ChallengePostID),
    });
};

// Fetch a single challenge post by ID
const fetchChallengePostById = async (id) => {
    if (!id) throw new Error('ChallengePost ID is required');
    const res = await client.get(`/api/challengeposts/${id}/specific-details`);
    return res.data;
};

// React Query hook
const useChallengePostById = (id) => {
    console.log('Fetching challenge post with ID:', id); // Debugging line
    
    return useQuery({
        queryKey: ['challengePost', id],
        queryFn: () => fetchChallengePostById(id),
        enabled: !!id, // only run if ID is present
    });
};

const regenerateChallengePost = async ({ challengeType, challengeTopic, durationDays, subtopicTitle }) => {
  const res = await client.post(`/api/challenge-posts/regenerate`, {
    challengeTypeid: challengeType,
    challengeTopic,
    durationDays,
    subtopicTitle,
  });
  return res.data;
};


const useRegenerateChallengePost = () => {
  return useMutation({
    mutationFn: regenerateChallengePost,
  });
};


export { useSubmitForm, fetchChallengeTypes, fetchChallengesByUser, useChallengePosts, useApproveChallengePost, useUpdateChallengePost, useChallengePostById, useRegenerateChallengePost };
